import React, { memo } from 'react';
import classnames from 'classnames';
import { componentInvariants } from 'bloko/common/helpers/customPropTypes';

import './item.less';

function Item({ Element, selected, selectable, ...elementProps }) {
    return (
        <Element
            {...elementProps}
            className={classnames('bloko-drop-menu-item', {
                'bloko-drop-menu-item_selected': selected,
                'bloko-drop-menu-item_selectable': selectable,
            })}
        />
    );
}

Item.propTypes = {
    Element: componentInvariants(['a', 'button']),
};

Item.defaultProps = {
    Element: 'a',
};

export default memo(Item);
